import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import ReportingDashboard from "./pages/ReportingDashboard";
import Report from "./pages/Report";

import MenuBar from "./components/MenuBar";
import UserGuide from "./pages/UserGuide";
import { connect } from "react-redux";

import { selectModule } from "../../store/common/actions";
import PrivateRoute from "../common/guard/PrivateRoute";
import { useRequiredAuth } from "../common/guard/requiredAuth";
const defaultRouters = [
  {
    to: "/reporting/dashboard",
    permissions: [
      "IS_ADMIN",
      "CAN_ACCESS_OVERSIGHT_REPORTING",
      "CAN_ACCESS_INSTITUTIONAL_REPORTING",
    ],
  },
  {
    to: "/reporting/reports",
    permissions: [
      "IS_ADMIN",
      "CAN_ACCESS_OVERSIGHT_REPORTING",
      "CAN_ACCESS_INSTITUTIONAL_REPORTING",
    ],
  },
];
const Layout = (props) => {
  const { hasPermissions } = useRequiredAuth();

  const renderDefaultRoute = () => {
    for (const router of defaultRouters) {
      if (hasPermissions(router.permissions)) {
        return router.to;
      }
    }

    // If no route is found with the necessary permissions, return the default route
    return "/unauthorized";
  };

  return (
    <React.Fragment>
      <MenuBar />
      <Switch>
        <PrivateRoute
          children={<ReportingDashboard />}
          permissions={[
            "IS_ADMIN",
            "CAN_ACCESS_OVERSIGHT_REPORTING",
            "CAN_ACCESS_INSTITUTIONAL_REPORTING",
          ]}
          path="/reporting/dashboard"
        />
        <PrivateRoute
          children={<Report />}
          permissions={[
            "IS_ADMIN",
            "CAN_ACCESS_OVERSIGHT_REPORTING",
            "CAN_ACCESS_INSTITUTIONAL_REPORTING",
          ]}
          path="/reporting/report"
        />
        <PrivateRoute
          children={<UserGuide />}
          permissions={[
            "IS_ADMIN",
            "CAN_ACCESS_OVERSIGHT_REPORTING",
            "CAN_ACCESS_INSTITUTIONAL_REPORTING",
          ]}
          path="/reporting/user-guide"
        />

        <Route
          path="/reporting"
          component={() => <Redirect to={renderDefaultRoute()} />}
        />
      </Switch>
    </React.Fragment>
  );
};

const mapStateToProps = ({ selectedModule }) => {
  return {
    selectedModule,
  };
};
export default connect(mapStateToProps, { selectModule })(Layout);
